import { Role } from "@/acl/roles";
import { WINVEST_PRODUCTS_DETAILS } from "@/assets/constants/products/winvest";

export default {
  orgName: "WINVEST ASSET MANAGEMENT",
  logoPath: require("@/assets/images/logo/winvest.png"),
  navBarLogoStyle: "width: 100%; max-height: 100px;",
  allowedLoginMethods: ["Google"],
  products: WINVEST_PRODUCTS_DETAILS,
  hasHoldingData: true,
  possibleRoles: [Role.superAdmin, Role.admin, Role.viewer],
  admin: true,
  availableLanguages: ["en", "de"],
  followFeatureActivated: true,
  colorScheme: [
    "#5c5ca2ff",
    "#5c5ca2bf",
    "#5c5ca27f",
    "#5c5ca23f",
    "#b89150ff",
    "#b89150bf",
    "#b891507f",
    "#b891503f",
    "#df6541ff",
    "#df6541bf",
    "#df65417f",
    "#df65413f",
    "#c24885ff",
    "#c24885bf",
    "#c248857f",
    "#c248853f",
  ],
};
